
    function switchTab(container, tabSelector, panelSelector, tab, prefix) {
      const target = tab.dataset.target
      container.querySelectorAll(tabSelector).forEach(t => {
        t.classList.remove("border-(--crit-brand)", "text-(--crit-brand)")
        t.classList.add("border-transparent", "text-(--crit-fg-muted)")
      })
      tab.classList.remove("border-transparent", "text-(--crit-fg-muted)")
      tab.classList.add("border-(--crit-brand)", "text-(--crit-brand)")
      container.querySelectorAll(panelSelector).forEach(p => p.classList.add("hidden"))
      const panel = container.querySelector("#" + prefix + target)
      if (panel) panel.classList.remove("hidden")
    }
    export default {
      mounted() {
        const prefix = this.el.dataset.panelPrefix || ""
        this.el.addEventListener("click", (e) => {
          const installTab = e.target.closest(".install-tab")
          if (installTab) switchTab(this.el, ".install-tab", ".install-panel", installTab, prefix)
          const agentTab = e.target.closest(".agent-tab")
          if (agentTab) switchTab(this.el, ".agent-tab", ".agent-panel", agentTab, prefix)
          const copyBtn = e.target.closest(".copy-btn, .agent-copy-btn")
          if (copyBtn) {
            let text
            if (copyBtn.dataset.copy) {
              text = copyBtn.dataset.copy
            } else {
              const pre = copyBtn.closest("div")?.querySelector("pre")
              if (pre) text = pre.textContent.replace(/^\$ /, "").replace(/ or .*$/, "").split("\n")[0].trim()
            }
            if (text) {
              navigator.clipboard.writeText(text).then(() => {
                const defaultIcon = copyBtn.querySelector(".icon-default")
                const copiedIcon = copyBtn.querySelector(".icon-copied")
                if (defaultIcon) defaultIcon.classList.add("hidden")
                if (copiedIcon) copiedIcon.classList.remove("hidden")
                setTimeout(() => {
                  if (defaultIcon) defaultIcon.classList.remove("hidden")
                  if (copiedIcon) copiedIcon.classList.add("hidden")
                }, 2000)
              }).catch(() => {})
            }
          }
        })
      }
    }
  